import type { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, Dialog } from '~/ui'

type Props = PropsWithChildren<{
  isOpen?: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void
  onCancel?: () => void
  isLoading?: boolean
  errorMessage?: string
}>

export const AlertDialog = ({
  isOpen,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  isLoading = false,
  errorMessage,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <Dialog.Content>
        {title && <Dialog.Title>{title}</Dialog.Title>}

        {description && (
          <Dialog.Description className="text-foreground/64">
            {description}
          </Dialog.Description>
        )}

        {errorMessage && (
          <div className="px-3">
            <Alert type="error" title={errorMessage} />
          </div>
        )}

        <Dialog.Actions>
          <Button isLoading={isLoading} onClick={onConfirm}>
            {confirmText ?? t('action.confirm')}
          </Button>
          <Dialog.Close asChild>
            <Button variant="ghost" onClick={onCancel}>
              {cancelText ?? t('action.cancel')}
            </Button>
          </Dialog.Close>
        </Dialog.Actions>
      </Dialog.Content>
    </Dialog>
  )
}
